import angular from 'angular';
import { isEmpty, range } from 'lodash';

import _css from './od-star-rating.less';

const ICON_SETS = {
  blue: {
    hover: 'star-hover',
    selected: 'star-filled-blue',
    default: 'star-empty',
  },
  gold: {
    hover: 'star-filled-gold',
    selected: 'star-filled-gold',
    default: 'star-empty-grey',
  }
};

module.exports = angular.module('common.directives.od-star-rating', [])
.component('odStarRating', {
  bindings: {
    ngModel: '=',
    ngChange: '&?',
    numStarsStr: '@?numStars',
    iconSet: '@?', // Choose from ICON_SETS above
    frozen: '<?', // Prevent editing. `true` or `false`, defaults to `false`
  },
  templateUrl: '/templates/common/directives/od-star-rating.html',
  controller: class {
    constructor($timeout) {
      this.ICON_SETS = ICON_SETS;
      this.$timeout = $timeout;
      
      this.numStars = parseInt(this.numStarsStr, 10) || 5;
      this.starNumbers = range(1, this.numStars + 1);
      this.hoveredStarNumber = null;
      if (isEmpty(this.iconSet)) {
        this.iconSet = 'blue';
      } else if (!ICON_SETS[this.iconSet]) {
        throw `Invalid icon set "${this.iconSet}" provided to od-star-rating.`;
      }
    }

    onMouseover(hoveredStarNumber) {
      if (this.frozen) {
        return;
      }

      this.hoveredStarNumber = hoveredStarNumber;
    }

    updateModel(newValue) {
      if (this.frozen) {
        return;
      }

      this.ngModel = newValue;

      if (this.ngChange) {
        // This is hack to prevent ngChange from being fired before the
        // $scope.$apply can finish propagating the new value. The best
        // alternative seems to be http://stackoverflow.com/a/34001183, but
        // this didn't work for me, and http://stackoverflow.com/a/25973789
        // is a possibly-even-worse-hack using scope.$eval.
        this.$timeout(() => {
          this.ngChange();
        });
      }
    }
  }
})
.name;



/** WEBPACK FOOTER **
 ** ./javascripts/common/directives/od-star-rating.js
 **/